import React from 'react'

export default function NumberBox({ label, value, onChange, suffix, className = 'w-36' }) {
  return (
    <label className={`flex h-11 items-center gap-2 rounded-lg border-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode px-3 text-sm focus-within:border-2 focus-within:border-rb-green ${className}`}>
      {label && <span className="text-xs text-rb-mat-grey dark:text-gray-400">{label}</span>}
      <input
        type="text"
        inputMode="decimal"
        value={value}
        onChange={({ target }) => onChange(target.value.replace(/[^\d.,]/g, ''))}
        className="w-full min-w-0 border-0 bg-transparent p-0 text-right text-rb-black dark:text-white focus:ring-0"
      />
      {suffix && <span className="text-rb-mat-grey dark:text-gray-400">{suffix}</span>}
    </label>
  )
}
